import { Injectable } from '@angular/core';
import { GoogleAnalyticsEventEnum } from './google-analytics-event.enum';
import { GoogleAnalyticsErrorEventBase, GoogleAnalyticsErrorTypes, GoogleAnalyticsFormErrorEvent } from './google-analytics-form-error-event.type';

declare const window: Window & { dataLayer: Partial<GoogleAnalyticsFormErrorEvent>[] };

/**
 * Service to track errors in Google Analytics
 */
@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsErrorService {
  constructor() {
    window.dataLayer = window.dataLayer || [];
  }

  trackFormValidationError(step: string, field: string, message: string) {
    this.push({
      event: GoogleAnalyticsEventEnum.QuoteFormError,
      step,
      error_type: GoogleAnalyticsErrorTypes.VALIDATION,
      field,
      message,
    });
  }

  trackFormSubmissionFailure(step: string, message: string, errorType: string) {
    this.push({
      event: GoogleAnalyticsEventEnum.QuoteSubmissionFailure,
      step,
      error_type: errorType,
      message,
    });
  }

  private push(event: GoogleAnalyticsErrorEventBase | GoogleAnalyticsFormErrorEvent) {
    window.dataLayer?.push(event);
  }
}
